
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...marketing-slug]",
      function () {
        return require("private-next-pages/[...marketing-slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...marketing-slug]"])
      });
    }
  